module.exports = __webpack_public_path__ + "media/images/shield_color-a2d99510.png";